import { render, staticRenderFns } from "./AccountProducts.vue?vue&type=template&id=c632541a&"
import script from "./AccountProducts.vue?vue&type=script&lang=js&"
export * from "./AccountProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports